import { useQuery } from "react-query";

import apiService from "@/services/api";
import type { DemoStatus } from "@/services/api";
import { useAuth } from "@/hooks/useAuth";

/**
 * Демо-статус текущего пользователя: признак, срок и остаток проверок.
 *
 * Обновляется раз в минуту и при возврате на вкладку — остаток меняется с
 * каждой проверкой. Для сотрудников платформы не запрашивается.
 */
export function useDemoStatus(): DemoStatus | undefined {
  const { user } = useAuth();
  const enabled = !!user && user.role === "CLIENT";
  const { data } = useQuery<DemoStatus>(["demo-status", user?.id], () => apiService.getDemoStatus(), {
    enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });
  return enabled ? data : undefined;
}
